"use client"

import { createContext, useContext, type ReactNode } from "react"
import {
  DEFAULT_BUSINESS_HOURS,
  type BusinessHoursSettings,
} from "@/lib/business-hours"

const BusinessHoursContext = createContext<BusinessHoursSettings>(
  DEFAULT_BUSINESS_HOURS
)

export function BusinessHoursProvider({
  value,
  children,
}: {
  value: BusinessHoursSettings
  children: ReactNode
}) {
  return (
    <BusinessHoursContext.Provider value={value}>
      {children}
    </BusinessHoursContext.Provider>
  )
}

/** The resolved business-hours settings for the active country. */
export function useBusinessHoursSettings(): BusinessHoursSettings {
  return useContext(BusinessHoursContext)
}
